export function modal(params) {
    const onOpen = params.onOpen;
    const onClose = params.onClose;

    if (!document.querySelector("[data-modal-target]")) {
        return;
    }

    const doc = document.documentElement;

    const SCROLL_WIDTH = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style = `--scrollWidth: ${SCROLL_WIDTH}px`;

    const openModal = (modal, target, content, action) => {
        if (target) {
            target.classList.add("active");
        }

        modal.classList.add("opened");

        setTimeout(() => {
            modal.classList.add("visible");
        }, 100);

        if (!doc.classList.contains("locked")) {
            doc.classList.add("locked");
        }

        onOpen?.({
            $root: content,
            action
        });
    };

    const closeModal = (modal) => {
        const modalContent = modal.querySelector("[data-modal-id]");
        const modalId = modalContent.dataset.modalId;

        const triggers = document.querySelectorAll(
            `[data-modal-target="${modalId}"], a[href="#${modalId}"]`
        );

        const modals = document.querySelectorAll("[data-modal]");
        const documentLocked = Array.from(modals).some((modal) =>
            modal.classList.contains("opened")
        );

        if (!documentLocked) {
            doc.classList.remove("locked");
        }

        triggers.forEach((trigger) => {
            trigger.classList.remove("active");
        });

        //modal.dataset.currentModal = "";
        modal.classList.remove("opened");
        modal.classList.remove("visible");

        onClose?.();
    };

    const handleClick = (e) => {
    
        const $opener = e.target.closest("[data-modal-target]") || e.target.closest('a[href*="#"][href*="Modal"]');
        const $closer = e.target.closest("[data-modal-close]");
        const $backdrop = e.target.closest("[data-modal-backdrop]");

        if ($opener) {
            e.preventDefault();
            const isDrawer = !!$opener.dataset.drawer;
            const isBottomSheet = !!$opener.dataset.bottomsheet;
            const isModal = !!$opener.dataset.modal;
            const href = $opener.getAttribute("href") || "";
            const modalTarget = $opener.dataset.modalTarget || new URL(href, window.location.href).hash.slice(1);
            const modalContent = document.querySelector(`[data-modal-id="${modalTarget}"]`);
            const action = $opener.dataset.action ?? "";

            if (!modalContent) {
                return;
            }

            let modalDest;
            let modal;

            if (isDrawer) {
                modalDest = document.getElementById("site-drawerModalDestination");
            } else if (isBottomSheet) {
                modalDest = document.getElementById("site-bottomSheetModalDestination");
            } else {
                modalDest = document.getElementById("site-modalModalDestination");
            }

            if (modalDest) {
                modal = modalDest.closest("[data-modal]");

                modal.dataset.currentModal = modalTarget;

                if ($opener.classList.contains("active")) {
                    closeModal(modal);
                    return;
                }

                modalDest.innerHTML = modalContent.outerHTML;

                openModal(modal, $opener, modalDest, action);
            }
        }

        if ($closer || $backdrop) {
            const $closeTrigger = $closer || $backdrop;
            const modal = $closeTrigger.closest("[data-modal]");

            if (modal) {
                closeModal(modal);
            }
        }
    };

    document.addEventListener("click", handleClick);
}